import { usePolarisVizContext, DEFAULT_CHART_PROPS, ChartState } from '@shopify/polaris-viz-core';
import { Chart } from './Chart.js';
import { jsx } from 'react/jsx-runtime';
import { ChartContainer } from '../ChartContainer/ChartContainer.js';
import { ChartSkeleton } from '../ChartSkeleton/ChartSkeleton.js';

function SparkLineChart(props) {
  const {
    defaultTheme
  } = usePolarisVizContext();
  const {
    data,
    accessibilityLabel,
    id,
    isAnimated,
    offsetLeft = 0,
    offsetRight = 0,
    onError,
    theme = defaultTheme,
    state,
    errorText
  } = { ...DEFAULT_CHART_PROPS,
    ...props
  };
  return /*#__PURE__*/jsx(ChartContainer, {
    id: id,
    isAnimated: isAnimated,
    data: data,
    theme: theme,
    sparkChart: true,
    onError: onError,
    children: state !== ChartState.Success ? /*#__PURE__*/jsx(ChartSkeleton, {
      type: "Spark",
      state: state,
      errorText: errorText,
      theme: theme
    }) : /*#__PURE__*/jsx(Chart, {
      data: data,
      accessibilityLabel: accessibilityLabel,
      offsetLeft: offsetLeft,
      offsetRight: offsetRight,
      theme: theme
    })
  });
}

export { SparkLineChart };
